import { NavigationLink } from 'components/NavigationLink';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const DirectoryItemStyled = styled(NavigationLink)(({ theme }) => ({
  backgroundColor: Colors.white,
  display: 'flex',
  alignItems: 'center',
  padding: '15px 16px',
  borderRadius: 12,
  cursor: 'pointer',
  border: `1px solid ${Colors.gray300}`,
  transition: theme.transitions.create(['background-color']),

  '&:hover': {
    backgroundColor: Colors.gray100,
  },
}));
